import Cookies from "js-cookie";
import type { CheckoutHandoff } from "@origin-digital/chat-client-sdk/unauth/internet";

const CART_ID_COOKIE_NAME = "cartId";
const INTERNET_ESSENTIALS_PATH = "/customisation/internet-essentials";
const MAX_OPAQUE_IDENTIFIER_LENGTH = 256;

export type InternetCheckoutHandoff = CheckoutHandoff;

const isOpaqueIdentifier = (value: unknown): value is string =>
  typeof value === "string" &&
  value.trim().length > 0 &&
  value.length <= MAX_OPAQUE_IDENTIFIER_LENGTH;

/** Defensively validate the SDK handoff before TAL performs host side effects. */
export function isInternetCheckoutHandoff(
  value: unknown
): value is InternetCheckoutHandoff {
  if (typeof value !== "object" || value === null) return false;

  return (
    isOpaqueIdentifier(Reflect.get(value, "cartId")) &&
    isOpaqueIdentifier(Reflect.get(value, "originAddressId"))
  );
}

export const saveCartId = (value: string, days?: number | undefined) => {
  const options: Cookies.CookieAttributes = {
    secure: true,
    httpOnly: false,
    sameSite: "Strict",
    expires: days ? days : 1,
  };

  Cookies.set(CART_ID_COOKIE_NAME, value, options);
};

export function internetEssentialsPath(originAddressId: string): string {
  const url = new URL(INTERNET_ESSENTIALS_PATH, window.location.origin);
  url.searchParams.set("useCart", "true");
  url.searchParams.set("originAddressId", originAddressId);
  return `${url.pathname}${url.search}`;
}

export function completeInternetCheckoutHandoff(
  handoff: InternetCheckoutHandoff
): void {
  saveCartId(handoff.cartId);
  window.location.assign(internetEssentialsPath(handoff.originAddressId));
}
